"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SmartphoneOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M23 1H9a2 2 0 00-2 2v26a2 2 0 002 2h14a2 2 0 002-2V3a2 2 0 00-2-2zm0 28H9v-4h14zm0-6H9V9h14zm0-16H9V3h14z"/><circle cx="16" cy="27" r="1"/><path d="M15 6h2a1 1 0 000-2h-2a1 1 0 000 2z"/><circle cx="12" cy="5" r="1"/>';
var SmartphoneOutlineSVG = function SmartphoneOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.SmartphoneOutlineSVG = SmartphoneOutlineSVG;
SmartphoneOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SmartphoneOutlineSVG);
exports.default = _default;